<ng-container *ngIf="first || !isSameDayDate">
    <li class="datebtn">
        <div class="datecss">
            {{formatedDate | titlecase}}
        </div>
    </li>
</ng-container>

<li class="datebtn">

    <ng-container *ngIf="!last && nextDate">
        <div class="linecss"></div>
    </ng-container>
    <div style="position: relative;display: flex; flex: 1 1 auto;">

        <ng-container>
            <div class="iconcss">
                <mat-icon class="icon-size-5 text-white">{{iconName}}
                </mat-icon>
            </div>
        </ng-container>




        <div class="Content">

            <!-- <ng-container *ngIf="activity.notes">
                <div [innerHTML]="activity.notes"></div>
            </ng-container> -->
            <div class="contain">

                <div class="text-secondary">
                    {{ dateShow | date:'MMM dd, h:mm a':'Asia/Kolkata' }}
                </div>


            </div>

            <!-- Extra content for Non-Email Activities -->
            <ng-container *ngIf="!isEmailActivity(activity.activityType)">
                <ng-container *ngIf="activity.subject;else other_content">
                    <div class="extracontent" [innerHTML]="activity.subject"></div>
                    <div *ngIf="activity.notes && activity.subject !== activity.notes"
                        class="extracontent" [innerHTML]="activity.notes">
                    </div>

                    <div *ngIf="activity.schedule &&
                        (activity.activityType === 'Phone Call' 
                        || activity.activityType === 'OutboundCall')
                        " style="margin-top: 10px;">
                        <div style="display: flex; align-items: center; gap: 12px; flex-wrap: wrap;">
                            <audio controls style="height: 38px; outline: none;">
                                <source [src]="getAudioUrl(activity.schedule)">
                            </audio>

                            <button class="btn btn-sm btn-primary" [disabled]="generatingAiMap[activity.id]" (click)="generateAiAnalysis(activity)" style="border-radius: 6px; padding: 6px 14px; font-weight: 500;">
                                <i class="fa fa-magic" *ngIf="!generatingAiMap[activity.id]"></i>
                                <i class="fa fa-spinner fa-spin" *ngIf="generatingAiMap[activity.id]"></i>
                                <span style="margin-left: 5px;">{{ generatingAiMap[activity.id] ? 'Generating AI...' : ((activity.transcript || activity.callSummary || activity.report) ? 'Re-generate AI' : 'Generate AI') }}</span>
                            </button>

                            <button *ngIf="activity.transcript || activity.callSummary || activity.report" class="btn btn-sm btn-outline-info" (click)="viewReport(activity)" style="border-radius: 6px; padding: 6px 14px; font-weight: 500;">
                                <i class="fa fa-file-text-o" style="margin-right: 5px;"></i> View AI Report
                            </button>
                        </div>
                    </div>
                    <div class="padding-10" *ngIf="activity.type==1">{{activity.typeMessage}}</div>

                    <div class="padding-10" *ngIf="activity.activityType == 'statusChange'">Updated by
                        {{activity.updatedBy}}</div>

                </ng-container>
                <ng-template #other_content>
                    <ng-container *ngIf="activity.notes">
                        <div class="extracontent" [innerHTML]="activity.notes"></div>

                        <div *ngIf="activity.schedule &&
                        (activity.activityType === 'Phone Call' 
                        || activity.activityType === 'OutboundCall')
                        " style="margin-top: 10px;">
                            <div style="display: flex; align-items: center; gap: 12px; flex-wrap: wrap;">
                                <audio controls style="height: 38px; outline: none;">
                                    <source [src]="getAudioUrl(activity.schedule)">
                                </audio>

                                <button class="btn btn-sm btn-primary" [disabled]="generatingAiMap[activity.id]" (click)="generateAiAnalysis(activity)" style="border-radius: 6px; padding: 6px 14px; font-weight: 500;">
                                    <i class="fa fa-magic" *ngIf="!generatingAiMap[activity.id]"></i>
                                    <i class="fa fa-spinner fa-spin" *ngIf="generatingAiMap[activity.id]"></i>
                                    <span style="margin-left: 5px;">{{ generatingAiMap[activity.id] ? 'Generating AI...' : ((activity.transcript || activity.callSummary || activity.report) ? 'Re-generate AI' : 'Generate AI') }}</span>
                                </button>

                                <button *ngIf="activity.transcript || activity.callSummary || activity.report" class="btn btn-sm btn-outline-info" (click)="viewReport(activity)" style="border-radius: 6px; padding: 6px 14px; font-weight: 500;">
                                    <i class="fa fa-file-text-o" style="margin-right: 5px;"></i> View AI Report
                                </button>
                            </div>
                        </div>
                        <div class="padding-10" *ngIf="activity.type==1">{{activity.typeMessage}}</div>

                        <div class="padding-10" *ngIf="activity.activityType == 'statusChange'">Updated by
                            {{activity.updatedBy}}</div>

                    </ng-container>
                </ng-template>
            </ng-container>

            <!-- HubSpot-Style Email Activity Card -->
            <div *ngIf="isEmailActivity(activity.activityType)" class="hubspot-email-card">
                <div class="hubspot-email-header" (click)="toggleEmailDetails(activity)">
                    <div class="header-left">
                        <span class="material-icons-outlined arrow-icon" [class.open]="activity.showEmailDetails">
                            chevron_right
                        </span>
                        <div class="email-badge">
                            <span class="material-icons-outlined">mail</span>
                        </div>
                        <div class="email-title-group">
                            <span class="activity-type-label">Email</span>
                            <span class="email-subject-heading">- {{ activity.subject || activity.emailSubject || 'Email Activity' }}</span>
                        </div>
                    </div>
                    <div class="header-right">
                        <span class="email-timestamp">{{ (activity.createdDate || date) | date:'MMM dd, yyyy h:mm a':'Asia/Kolkata' }}</span>
                    </div>
                </div>

                <div class="hubspot-email-body" *ngIf="activity.showEmailDetails" [@expandCollapse]="activity.showEmailDetails ? 'open' : 'closed'">
                    <div class="email-meta-bar">
                        <div class="sender-avatar">
                            <span class="material-icons-outlined">person</span>
                        </div>
                        <div class="sender-info">
                            <div class="sender-name-line">
                                <span class="sender-name">{{ activity.updatedBy || activity.fromEmail || 'Sender' }}</span>
                                <span class="recipient-to" *ngIf="activity.customerName || activity.toEmail">to {{ activity.customerName || activity.toEmail }}</span>
                            </div>
                            <div class="recipient-details" *ngIf="activity.fromEmail || activity.toEmail">
                                <span *ngIf="activity.fromEmail"><strong>From:</strong> {{ activity.fromEmail }}</span>
                                <span *ngIf="activity.toEmail" style="margin-left: 12px;"><strong>To:</strong> {{ activity.toEmail }}</span>
                            </div>
                        </div>
                        <div class="sent-tag">
                            <span class="badge-sent">Sent</span>
                        </div>
                    </div>

                    <div class="email-copy-info" *ngIf="activity.cc || activity.bcc">
                        <span *ngIf="activity.cc"><strong>CC:</strong> {{ activity.cc }}</span>
                        <span *ngIf="activity.bcc" style="margin-left: 12px;"><strong>BCC:</strong> {{ activity.bcc }}</span>
                    </div>

                    <div class="email-message-box" *ngIf="activity.emailBody || activity.notes">
                        <div class="email-message-content" [innerHTML]="activity.emailBody || activity.notes"></div>
                    </div>
                </div>
            </div>


            <!-- <ng-container *ngIf="!activity.notes">
                <div class="extracontent" [innerHTML]="activity.customerAddress"></div>
            </ng-container> -->

            <ng-container *ngIf="activity.activityIcon">

                <div style="margin-top: 10px;">
                    <audio controls>
                        <source [src]="getAudioUrl(activity.activityIcon)">
                    </audio>
                </div>

            </ng-container>
        </div>
    </div>
</li>

<!-- Content Modal Dialog -->
<ng-template #contentDialog>
  <div style="padding: 20px 24px; max-height: 80vh; display: flex; flex-direction: column; background-color: #ffffff; color: #212529; border-radius: 8px;">
    <!-- Modal Header -->
    <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #e9ecef; padding-bottom: 12px; margin-bottom: 16px;">
      <h4 style="margin: 0; font-weight: 700; color: #1e293b; font-size: 18px;">
        <i class="fa fa-magic" style="color: #6366f1; margin-right: 8px;"></i> AI Call Analysis & Report
      </h4>
      <i class="fa fa-times" (click)="closeModal()" mat-dialog-close style="font-size: 22px; color: #64748b; cursor: pointer; padding: 4px;" title="Close"></i>
    </div>

    <!-- Scrollable Content Body -->
    <div style="flex: 1; overflow-y: auto; padding-right: 4px;">
      <!-- Section 1: Call Summary -->
      <div *ngIf="selectedActivity?.callSummary" style="margin-bottom: 20px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 16px;">
        <h5 style="margin-top: 0; margin-bottom: 8px; font-size: 15px; font-weight: 600; color: #0f172a; display: flex; align-items: center;">
          <i class="fa fa-align-left" style="color: #3b82f6; margin-right: 8px;"></i> Call Summary
        </h5>
        <div style="white-space: pre-wrap; font-size: 14px; color: #334155; line-height: 1.6;">
          {{ selectedActivity.callSummary }}
        </div>
      </div>

      <!-- Section 2: Call Transcript -->
      <div *ngIf="selectedActivity?.transcript" style="margin-bottom: 20px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 16px;">
        <h5 style="margin-top: 0; margin-bottom: 8px; font-size: 15px; font-weight: 600; color: #0f172a; display: flex; align-items: center;">
          <i class="fa fa-file-text-o" style="color: #10b981; margin-right: 8px;"></i> Call Transcript
        </h5>
        <div style="white-space: pre-wrap; font-size: 13.5px; color: #334155; line-height: 1.6; max-height: 200px; overflow-y: auto; background: #ffffff; padding: 12px; border-radius: 6px; border: 1px solid #cbd5e1;">
          {{ selectedActivity.transcript }}
        </div>
      </div>

      <!-- Section 3: AI Executive Report -->
      <div *ngIf="selectedActivity?.report" style="margin-bottom: 12px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 16px;">
        <h5 style="margin-top: 0; margin-bottom: 8px; font-size: 15px; font-weight: 600; color: #0f172a; display: flex; align-items: center;">
          <i class="fa fa-bar-chart" style="color: #8b5cf6; margin-right: 8px;"></i> AI Executive Report
        </h5>
        <div style="white-space: pre-wrap; font-size: 14px; color: #334155; line-height: 1.6;">
          {{ selectedActivity.report }}
        </div>
      </div>
    </div>

    <!-- Sticky Modal Footer -->
    <div style="display: flex; justify-content: flex-end; border-top: 1px solid #e2e8f0; padding-top: 12px; margin-top: 12px;">
      <button (click)="closeModal()" mat-dialog-close class="btn btn-secondary" style="padding: 6px 20px; font-weight: 500; border-radius: 6px; cursor: pointer;">Close</button>
    </div>
  </div>
</ng-template>